import { getImage } from '@utils/imageHelper';
import Typography from 'aquilla/core/atoms/Typography';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Button from 'aquilla/core/molecules/Button';
import pushRoute from '@utils/pushRoute';

interface EmptyStateProps {
  goalRelativeLink: string;
  type: 'batches' | 'courses';
}

const Empty = styled.div`
  grid-column: span 18;
  text-align: center;
  margin-top: ${Spacings.SPACING_24B};
`;

const EmptyImage = styled.img`
  user-drag: none;
  user-select: none;
`;

const NoCourses = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
`;

const BrowseButton = styled(Button)`
  margin: ${Spacings.SPACING_5B} auto;
`;

export default function EmptyState(props: EmptyStateProps) {
  const { goalRelativeLink, type } = props;

  const handleBrowse = (e) => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/browse',
      `${goalRelativeLink}/browse`
    );
  };

  return (
    <Empty>
      <EmptyImage src={`${getImage('empty.svg')}`} alt="" />
      <NoCourses variant="h3">No {type} found</NoCourses>
      <Typography variant="p2" color="var(--color-text-secondary)">
        {`You haven't enrolled in any ${type} yet.`}
      </Typography>
      <BrowseButton label="Browse" onClick={handleBrowse} variant="brand" />
    </Empty>
  );
}
